import * as React from "react";

const up_svg = (
  <svg
    className={"up_svg"}
    fill="#000000"
    width="18px"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 407.436 407.436"
    xmlSpace="preserve"
  >
    <polygon points="203.718,91.567 0,294.621 21.179,315.869 203.718,133.924 386.258,315.869 407.436,294.621 " />
  </svg>
);

const down_svg = (
  <svg
    className={"down_svg icon_svg"}
    fill="#000000"
    width="18px"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 407.436 407.436"
    xmlSpace="preserve"
  >
    <polygon points="203.718,315.869 0,112.815 21.179,91.567 203.718,273.512 386.258,91.567 407.436,112.815" />
  </svg>
);

export { down_svg, up_svg };
